import React, { useEffect, useState } from "react";
import FileList from "./FileList";
import { login, getUserFromToken, logout, forceFreshLogin } from "./auth";

function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const u = getUserFromToken();
    if (u) {
      setUser(u);
      // Set session marker after successful token validation
      sessionStorage.setItem("cognito_session", "active");
    } else {
      // Check if we have stale localStorage data without valid session
      const storedUsername = localStorage.getItem("username");
      const hasSession = sessionStorage.getItem("cognito_session");
      
      if (storedUsername && !hasSession) {
        forceFreshLogin();
      } else {
        // Fresh page load, normal login
        login();
      }
    }
  }, []);

  return (
    <div className="App">
      {user && (
        <>
          <div style={{ textAlign: "right", padding: "10px 20px" }}>
            Logged in as <strong>{user.email}</strong>
            <button
              onClick={logout}
              style={{
                marginLeft: 10,
                padding: "6px 12px",
                backgroundColor: "#dc3545",
                color: "#fff",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                fontWeight: "bold",
              }}
            >
              Logout
            </button>
          </div>
          <FileList />
        </>
      )}
       {/* <FileList />  */}
    </div>
  );
}

export default App;
